import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import claimTypes from "../../constants/claimTypes";
import roleManagementService from "../../services/roleManagementService";
import EditForm from "../../components/containers/edit_form";
import { FormBodyFlexRow } from "../../components/containers/form_body";
import { FlexColumnMargin10 } from "../../components/containers/styled";
import { FieldContainer } from "../../components/inputs/field_container";
import InputForProperty from "../../components/inputs/inputForProperty";
import Loader from "../../components/loader/loader";
import ClaimsListView from "./components/claims_list_view";

const emptyRole = {
    roleName: "",
    description: "",
    claims: []
};

const EditRole = (props) => {
    const { match, history, t } = props;
    const [isNewRole, setIsNewRole] = useState(true);
    const [role, setRole] = useState({ ...emptyRole })
    const [validationError, setValidationError] = useState(false);
    const [loading, setLoading] = useState(false);

    const roles = useSelector(state => state.roles.roles);

    useEffect(() => {
        setLoading(true);
        const roleName = match.params.roleName;
        getRole(roleName);
    }, []);

    const getRole = async (roleName) => {
        if (!roleName) {
            setIsNewRole(true);
            setLoading(false);
            return;
        }
        const r = await roleManagementService.getRoleAsync(roleName);
        setIsNewRole(false);
        setRole(r);
        setLoading(false);
    }

    const updateRoleField = (propertyName, value) => {
        const r = { ...role };
        r[propertyName] = value;
        setRole(r);
        if (validationError) {
            validateFields(r);
        }
    }

    const setClaim = (claim, checked) => {
        const newRole = { ...role, claims: role.claims.filter(cl => cl.claimName !== claim.claimName) };

        if (checked) {
            newRole.claims.push(claim);
        }

        setRole(newRole);
    }

    const validateFields = (roleState) => {
        let isValid = true;
        if (isNewRole && roles.find(item => item.roleName.toLowerCase() === roleState.roleName.toLowerCase())) {
            setValidationError(t("RoleManagement.roleNameAlreadyExistsError"));
            isValid = false;
        }
        else {
            setValidationError(null);
        }

        return isValid;
    }

    const submit = async () => {
        try {
            if (!validateFields(role)) {
                return;
            }

            if (isNewRole) {
                await roleManagementService.addRoleAsync(role);
            }
            else {
                await roleManagementService.updateRoleAsync(role);
            }

            history.replace('/roles');
        }
        catch (e) {

        }
    }

    const cancel = async () => {
        history.replace('/roles');
    }

    return (
        <EditForm submit={submit} cancel={cancel}>
            <FormBodyFlexRow>
                <FlexColumnMargin10>
                    <FieldContainer>
                        <InputForProperty header={t("RoleManagement.roleName")} validationError={validationError}
                            onChange={updateRoleField} disabled={!isNewRole}
                            value={role.roleName} propertyName="roleName" />
                    </FieldContainer>
                    <FieldContainer>
                        <InputForProperty header={t("RoleManagement.roleDescription")} onChange={updateRoleField}
                            value={role.description} propertyName="description" />
                    </FieldContainer>
                </FlexColumnMargin10>
                <FlexColumnMargin10>
                    <FieldContainer>
                        <ClaimsListView claimsType={claimTypes.MODULE_ACCESS} roleClaims={role.claims} setClaim={setClaim}></ClaimsListView>
                    </FieldContainer>
                    <FieldContainer>
                        <ClaimsListView claimsType={claimTypes.FIELD_ACCESS} roleClaims={role.claims} setClaim={setClaim}></ClaimsListView>
                    </FieldContainer>
                </FlexColumnMargin10>
            </FormBodyFlexRow>
            {loading && <Loader />}
        </EditForm>
    )
}

export default withRouter(withTranslation("translations")(EditRole));